import { IconLoopExit } from '@components/icons/loop-exit';
import { hideSidebar, Sidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import {
  ActionHeader,
  ActionSidebarLoading,
  SidebarProps,
} from 'ui/journey-builder/node-types/common';

import { ConditionFormContent } from '../condition/helpers';

type ActionType = 'break_loop';

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);
  const values = data?.values;

  if (isLoading || !data) {
    return (
      <ActionSidebarLoading
        title={t('breakLoop')}
        icon={IconLoopExit}
        iconColor="elementRed100"
        {...props}
      />
    );
  }

  return (
    <Sidebar>
      <ActionHeader
        title={t('breakLoop')}
        icon={IconLoopExit}
        iconColor="elementRed100"
        {...props}
      />
      <Sidebar.Content>
        <ConditionFormContent
          action={data}
          onCancel={hideSidebar}
          journeyId={data.journey}
          conditionDescription={t('breakLoop')}
          hideActionButtons
          onSubmit={(data) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: 'break_loop',
              values: {
                loopAction: values?.loopAction,
                ...data,
              },
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    breakLoop: 'Exit loop',
  },
};
